import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';

export default class DefaultTreeRenderer extends Component {

  static displayName = 'DefaultTreeRenderer';

  static propTypes = {
    column: PropTypes.string,
    columnIndex: PropTypes.number,
    iconName: PropTypes.string,
    item: PropTypes.object,
    onBlur: PropTypes.func,
    onKeyDown: PropTypes.func,
    onChange: PropTypes.func,
    title: PropTypes.string,
    value: PropTypes.string,
  };

  static defaultProps = {
    iconName: 'folder',
  };

  shouldComponentUpdate(nextProps) {
    const { column, columnIndex, item } = this.props;

    return nextProps.column !== column || nextProps.columnIndex !== columnIndex || nextProps.item !== item ||
      (nextProps.item && nextProps.item[column]) !== (item && item[column]) || this.props.onChange !== nextProps.onChange ||
      this.props.value !== nextProps.value;
  }

  render() {
    const { column, columnIndex, iconName, item, onChange, title } = this.props;

    return (
      <span className="core-default-tree-item">
        {columnIndex === 0 && <Icon name={iconName} className="folder type-icon"/>}
        {!onChange ? title || item[column] : <input className="cell-input" value={this.props.value} onChange={onChange} onKeyDown={this.props.onKeyDown} onBlur={this.props.onBlur} autoFocus/>}
      </span>
    );
  }

}
